<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Fo0Qn/tc-custom/9781473885202.jpg?1704761626292" alt="This image is the cover for the book Waste of Blood & Treasure"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Waste of Blood & Treasure
      </h1>
      <p class="bookDescription body article font2">
        <p>With the Netherlands overrun by French Republican forces, the British and Russian governments sent an allied army of 48,000 men under the Duke of York to liberate the country and restore the House of Orange.The largest operation mounted by Pitt's ministry during the French Revolutionary Wars, the amphibious expedition involved the first ever direct cooperation between British and Russian forces, embroiled the armies in five full-scale battles, and secured the capture of the Dutch fleet. As Britain's first major continental involvement since 1795, it played a part in shaping the early careers of many famous military commanders of the Napoleonic Wars. In the end, however, the campaign failed spectacularly. Its inglorious end provoked parliamentary outrage and led to diplomatic rupture between Britain and Russia. The Duke of York never commanded an army in the field again.This book examines British, French, Dutch and Russian sources to reveal a fascinating tale of intrigue, diplomatic skullduggery and daring action. Spies, politicians, sailors and soldiers all play a part in the exciting story of an expedition that made (and broke) reputations and tested alliances. It recounts in lavish detail the series of battles fought to liberate a people who showed little interest in being saved and explores the story behind the triumphs and failures of this forgotten campaign.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philip Ball
      </h2>
      
      <p class="authorDescription body article">Philip Ball has a long standing interest in military history and worked for a number of years in museums, archaeology and the heritage industry. Holding degrees from St David's, Leicester and Birmingham Universities he wrote his Masters Dissertation on the failure of the Helder campaign and is currently researching British maritime operations in the Revolutionary and Napoleonic Wars.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen & Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8ed6a8f2